import {notificationUtils} from "./notificationUtils";
import {emptyHook} from "./emptyHooks";

/**
 *
 * @param {import('axios').AxiosError} error
 * @param {Function} setLoading
 * @param {Function} setError
 * @returns {*|{context: string, text: string, title: string}}
 */
const parseErrorClient = (error, setLoading = emptyHook, setError = emptyHook) => {
    let target = parserError(error)
    setError(target.text)
    setLoading(false)
    return target
}

/**
 *
 * @param {import('axios').AxiosError} error
 * @returns {*|{context: string, text: string, title: string}}
 */
const parserError = (error) => {
    if (error?.response) {
        return filterErrors(error.response.data)
    }
    return filterErrors()
}
const filterErrors = (data) => {
    if (!data) return buildErrorContext(data)
    else if (Array.isArray(data?.message))  return buildErrorContext(data.message.join(" , "))
    else if (data?.message) return buildErrorContext(data.message)
}

const buildErrorContext = (message) => (
    notificationUtils({
    context: 'error', text: buildErrorText(message)
}))

const buildErrorText = (message) => {
    const typeMessage = typeof message
    const defaultMessage = 'Service Unavailable'
    if (!message?.toString().trim()) return `${defaultMessage}`
    const notPrimitive = !(typeMessage === 'string' || typeMessage === 'number')
    if (notPrimitive) return `${defaultMessage} | code 1 | details: ${JSON.stringify(message)}`
    return message
}
export default parseErrorClient